import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_chevronUpsr3kotv1e08s as get_chevronUp } from '../../icons.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Companion_getInstanceeghlbkcb6su6 as Companion_getInstance_0,
  Angle36m0cdko0c63j as Angle,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Angle.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_empty2lwyggrwaqgos as get_empty,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { ReactiveContextSuspending39biijty1bpc5 as ReactiveContextSuspending } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { Key_instance6wd16m35aua5 as Key_instance } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { ExpandButtonSemantic_getInstance3eedzzd1fkase as ExpandButtonSemantic_getInstance } from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from './nav/AppDimensions.mjs';
import { SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance } from '../theming/sections.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  unreadIconVisibley9o01zmxr3gz as unreadIconVisible,
  unreadIconWhen1430ixd91bo9h as unreadIconWhen,
} from './iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  get_rotation2o00xy9g08m4u as get_rotation,
  set_rotationrdhjwh8aps06 as set_rotation,
} from '../../actuals/rotation.mjs';
import { toggle1hhzkiumllyqn as toggle } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function expandIcon(_this__u8e3s4, expanded, extraSetup) {
  var tmp;
  if (extraSetup === VOID) {
    tmp = expandIcon$lambda;
  } else {
    tmp = extraSetup;
  }
  extraSetup = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.qbt(get_chevronUp(Companion_getInstance()));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = _get_rotation_$ref_mwbk4(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('rotation', 0, tmp_0, tmp_1, _set_rotation_$ref_g6n248(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = new (Angle())($this$reactiveScope.baj(expanded) ? Companion_getInstance_0().eb2_1 : Companion_getInstance_0().gb2_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  var tmp_2 = KMutableProperty0();
  var tmp_3 = IconView$_get_description_$ref_x7iif6(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('description', 0, tmp_2, tmp_3, IconView$_set_description_$ref_rpvc1e(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$2 = $this$reactiveScope.baj(expanded) ? 'collapse' : 'expand';
    this_1.set(tmp$ret$2);
    return Unit_instance;
  });
  extraSetup(view);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function expandIcon_0(_this__u8e3s4, expanded) {
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.qbt(get_chevronUp(Companion_getInstance()));
  var tmp = KMutableProperty0();
  var tmp_0 = IconView$_get_description_$ref_x7iif6_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (expanded($this$reactiveScope)) {
      tmp = 'collapse';
    } else {
      tmp = 'expand';
    }
    var tmp$ret$1 = tmp;
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  var tmp_1 = KMutableProperty0();
  var tmp_2 = _get_rotation_$ref_mwbk4_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('rotation', 0, tmp_1, tmp_2, _set_rotation_$ref_g6n248_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (expanded($this$reactiveScope)) {
      tmp = Companion_getInstance_0().eb2_1;
    } else {
      tmp = Companion_getInstance_0().gb2_1;
    }
    var tmp$ret$4 = new (Angle())(tmp);
    this_1.set(tmp$ret$4);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function expandAction(expanded) {
  var tmp = get_empty(Companion_getInstance());
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_1();
  var tmp_0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
  return Action('Toggle Expanded', tmp, VOID, VOID, tmp_0, VOID, expandAction$slambda_0(expanded));
}
function expandAndDelayMarkAsReadAction(expanded, update) {
  var localUpdate = {_v: null};
  var tmp = get_empty(Companion_getInstance());
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_1();
  var tmp_0 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
  return Action('Expand and mark as read on close', tmp, VOID, VOID, tmp_0, VOID, expandAndDelayMarkAsReadAction$slambda_0(expanded, localUpdate, update));
}
function expandAndMarkAsReadAction(_this__u8e3s4, expanded, unread) {
  var localUpdate = {_v: null};
  // Inline function 'com.lightningkite.reactive.context.reactiveSuspending' call
  var action = expandAndMarkAsReadAction$slambda_0(expanded, unread, localUpdate);
  // Inline function 'kotlin.also' call
  var this_0 = new (ReactiveContextSuspending())(_this__u8e3s4, VOID, VOID, action);
  this_0.yai();
  var tmp0_safe_receiver = _this__u8e3s4.ea2().cd(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.cah(this_0);
  }
  var tmp = get_empty(Companion_getInstance());
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_1();
  var tmp_0 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
  return Action('Expand and mark as read on close', tmp, VOID, VOID, tmp_0, VOID, expandAndMarkAsReadAction$slambda_2(expanded, localUpdate));
}
function expandButton(_this__u8e3s4, expanded, customAction, contents) {
  customAction = customAction === VOID ? null : customAction;
  var tmp = _this__u8e3s4.hbb(ExpandButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.eba(get_px(0));
  view.zb8(get_px(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_AppDimensions().mg2_1);
  contents(view_0);
  view_0.jbb(get_centered(view_0), expandIcon(view_0, expanded));
  view.fbb(p_0, view_0);
  view.mbg(customAction == null ? expandAction(expanded) : customAction);
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
}
function leftExpandButton(_this__u8e3s4, expanded, highlightOnExpand, padding, customAction, unread, contents) {
  highlightOnExpand = highlightOnExpand === VOID ? true : highlightOnExpand;
  padding = padding === VOID ? get_AppDimensions().pg2_1 : padding;
  customAction = customAction === VOID ? null : customAction;
  unread = unread === VOID ? null : unread;
  var tmp = _this__u8e3s4.hbb(ExpandButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  if (highlightOnExpand) {
    dynamicTheme(view, ($this$dynamicTheme) => $this$dynamicTheme.baj(expanded) ? SectionSemantic_getInstance() : null);
  }
  view.eba(padding);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_AppDimensions().mg2_1);
  if (!(unread == null)) {
    get_centered(view_0);
    unreadIconVisible(view_0, ($this$unreadIconVisible) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      return unread($this$unreadIconVisible);
    });
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance_2();
  }
  view_0.jbb(get_centered(view_0), expandIcon(view_0, expanded));
  get_centered(view_0);
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  contents(view_0);
  Companion_getInstance_2();
  view.fbb(p_0, view_0);
  view.mbg(customAction == null ? expandAction(expanded) : customAction);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function leftExpandButtonWithUnread(_this__u8e3s4, expanded, unread, highlightOnExpand, padding, contents) {
  highlightOnExpand = highlightOnExpand === VOID ? true : highlightOnExpand;
  padding = padding === VOID ? get_AppDimensions().pg2_1 : padding;
  var tmp = _this__u8e3s4.hbb(ExpandButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  if (highlightOnExpand) {
    dynamicTheme(view, ($this$dynamicTheme) => $this$dynamicTheme.baj(expanded) ? SectionSemantic_getInstance() : null);
  }
  view.eba(padding);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_AppDimensions().mg2_1);
  get_centered(view_0);
  unreadIconWhen(view_0, ($this$unreadIconWhen) => $this$unreadIconWhen.baj($this$unreadIconWhen.baj(unread)));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance_2();
  view_0.jbb(get_centered(view_0), expandIcon(view_0, expanded));
  get_centered(view_0);
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  contents(view_0);
  Companion_getInstance_2();
  view.fbb(p_0, view_0);
  view.mbg(expandAndMarkAsReadAction(view, expanded, unread));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function expandIcon$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function _get_rotation_$ref_mwbk4(p0) {
  return () => {
    var tmp0 = p0;
    return new (Angle())(get_rotation(tmp0));
  };
}
function _set_rotation_$ref_g6n248(p0) {
  return (_this__u8e3s4) => {
    var tmp0 = p0;
    set_rotation(tmp0, _this__u8e3s4.ycx_1);
    return Unit_instance;
  };
}
function IconView$_get_description_$ref_x7iif6(p0) {
  return () => p0.pbt_1;
}
function IconView$_set_description_$ref_rpvc1e(p0) {
  return (_this__u8e3s4) => {
    p0.ebu(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_description_$ref_x7iif6_0(p0) {
  return () => p0.pbt_1;
}
function IconView$_set_description_$ref_rpvc1e_0(p0) {
  return (_this__u8e3s4) => {
    p0.ebu(_this__u8e3s4);
    return Unit_instance;
  };
}
function _get_rotation_$ref_mwbk4_0(p0) {
  return () => {
    var tmp0 = p0;
    return new (Angle())(get_rotation(tmp0));
  };
}
function _set_rotation_$ref_g6n248_0(p0) {
  return (_this__u8e3s4) => {
    var tmp0 = p0;
    set_rotation(tmp0, _this__u8e3s4.ycx_1);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  var tmp = toggle($this.xga_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var expandAction$slambdaClass;
function expandAction$slambda() {
  if (expandAction$slambdaClass === VOID) {
    class $ {
      constructor($expanded) {
        this.xga_1 = $expanded;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    expandAction$slambdaClass = $;
  }
  return expandAction$slambdaClass;
}
function expandAction$slambda_0($expanded) {
  var i = new (expandAction$slambda())($expanded);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = $this.zga_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.yga_1._v = tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.agb_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var willExpand = !tmp;
  if (willExpand) {
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, expandAndDelayMarkAsReadAction$slambda$slambda_0($this.bgb_1, $this.cgb_1));
  } else {
    var tmp0_safe_receiver = $this.bgb_1._v;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    $this.bgb_1._v = null;
  }
  var tmp_1 = $this.agb_1.gah(willExpand, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var expandAndDelayMarkAsReadAction$slambda$slambdaClass;
function expandAndDelayMarkAsReadAction$slambda$slambda() {
  if (expandAndDelayMarkAsReadAction$slambda$slambdaClass === VOID) {
    class $ {
      constructor($localUpdate, $update) {
        this.yga_1 = $localUpdate;
        this.zga_1 = $update;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    expandAndDelayMarkAsReadAction$slambda$slambdaClass = $;
  }
  return expandAndDelayMarkAsReadAction$slambda$slambdaClass;
}
function expandAndDelayMarkAsReadAction$slambda$slambda_0($localUpdate, $update) {
  var i = new (expandAndDelayMarkAsReadAction$slambda$slambda())($localUpdate, $update);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var expandAndDelayMarkAsReadAction$slambdaClass;
function expandAndDelayMarkAsReadAction$slambda() {
  if (expandAndDelayMarkAsReadAction$slambdaClass === VOID) {
    class $ {
      constructor($expanded, $localUpdate, $update) {
        this.agb_1 = $expanded;
        this.bgb_1 = $localUpdate;
        this.cgb_1 = $update;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    expandAndDelayMarkAsReadAction$slambdaClass = $;
  }
  return expandAndDelayMarkAsReadAction$slambdaClass;
}
function expandAndDelayMarkAsReadAction$slambda_0($expanded, $localUpdate, $update) {
  var i = new (expandAndDelayMarkAsReadAction$slambda())($expanded, $localUpdate, $update);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.dgb_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.egb_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var u = tmp_0;
    var tmp0_safe_receiver = u.wfu_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp_1 = tmp0_safe_receiver($completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
    var tmp1_safe_receiver = u.xfu_1;
    var tmp_2;
    if (tmp1_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp_3 = tmp1_safe_receiver($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      tmp_2 = tmp_3;
    }
    $this.fgb_1._v = tmp_2;
  }
  return Unit_instance;
}
var expandAndMarkAsReadAction$slambdaClass;
function expandAndMarkAsReadAction$slambda() {
  if (expandAndMarkAsReadAction$slambdaClass === VOID) {
    class $ {
      constructor($expanded, $unread, $localUpdate) {
        this.dgb_1 = $expanded;
        this.egb_1 = $unread;
        this.fgb_1 = $localUpdate;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    expandAndMarkAsReadAction$slambdaClass = $;
  }
  return expandAndMarkAsReadAction$slambdaClass;
}
function expandAndMarkAsReadAction$slambda_0($expanded, $unread, $localUpdate) {
  var i = new (expandAndMarkAsReadAction$slambda())($expanded, $unread, $localUpdate);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ggb_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var currentlyExpanded = tmp;
  if (currentlyExpanded) {
    var tmp0_safe_receiver = $this.hgb_1._v;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    $this.hgb_1._v = null;
  }
  var tmp_0 = $this.ggb_1.gah(!currentlyExpanded, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var expandAndMarkAsReadAction$slambdaClass_0;
function expandAndMarkAsReadAction$slambda_1() {
  if (expandAndMarkAsReadAction$slambdaClass_0 === VOID) {
    class $ {
      constructor($expanded, $localUpdate) {
        this.ggb_1 = $expanded;
        this.hgb_1 = $localUpdate;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    expandAndMarkAsReadAction$slambdaClass_0 = $;
  }
  return expandAndMarkAsReadAction$slambdaClass_0;
}
function expandAndMarkAsReadAction$slambda_2($expanded, $localUpdate) {
  var i = new (expandAndMarkAsReadAction$slambda_1())($expanded, $localUpdate);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  expandAction as expandAction2iatt63opw8h9,
  expandAndDelayMarkAsReadAction as expandAndDelayMarkAsReadAction7idih42oelvd,
  expandAndMarkAsReadAction as expandAndMarkAsReadAction24de04tkd12ld,
  expandButton as expandButtonu3usotf5fiqs,
  expandIcon as expandIcon1as9er6lyg7in,
  expandIcon_0 as expandIcon33yq4ree5qq5m,
  leftExpandButtonWithUnread as leftExpandButtonWithUnread1gpbgdpec45fr,
  leftExpandButton as leftExpandButton23soimuuf6gel,
};
//endregion

//# sourceMappingURL=expansion.mjs.map
